module.exports = __webpack_public_path__ + "static/media/example-bag-image.0b16e26f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/example-bag-image.png
// module id = 667
// module chunks = 0